interface AwardRowProps {
	date: string
	ceremony: string
	award: string
}

export default function AwardRow({date, ceremony, award}:AwardRowProps) {
	return (
		<div className="site-grid items-center group border-t border-grey dark:border-grey-dark py-4 sm:py-6">
			<div className="col-span-full md:col-span-2 relative z-200 text-base leading-130 text-grey dark:text-grey-dark">{date}</div>
			<div className="mt-1 sm:mt-0 col-span-full md:col-span-4 font-400 text-xl leading-110">{ceremony}</div>
			<div className="mt-1 sm:mt-0 col-span-full md:col-span-6 relative z-200 font-400 text-xl leading-110 text-black dark:text-white">{award}</div>
		</div>
	)
}